(function() {
  'use strict';
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.BaseHandler = (function(superClass) {
    extend(BaseHandler, superClass);

    function BaseHandler() {
      this.getDateString = bind(this.getDateString, this);
      return BaseHandler.__super__.constructor.apply(this, arguments);
    }

    BaseHandler.prototype.resetFilters = function() {
      var f, fg, i, len, ref, results;
      ref = this.parent.filters.filter_groups();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        fg = ref[i];
        results.push((function() {
          var j, len1, ref1, results1;
          ref1 = fg.filters();
          results1 = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            f = ref1[j];
            results1.push(f.enableFilter());
          }
          return results1;
        })());
      }
      return results;
    };

    BaseHandler.prototype.hideAllFilterGroups = function() {
      var group, i, len, ref, results;
      ref = this.parent.filters.filter_groups();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        results.push(this.parent.filters.hideGroup(group.name));
      }
      return results;
    };

    BaseHandler.prototype.disableAllFilterGroups = function() {
      var group, i, len, ref, results;
      ref = this.parent.filters.filter_groups();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        results.push(this.parent.filters.disableGroup(group.name));
      }
      return results;
    };

    BaseHandler.prototype.importDefaultFilters = function() {
      var locale, stateDisplay, zipDisplay;
      locale = window.Config.get('app.locale');
      stateDisplay = locale === 'en_CA' ? 'Province' : 'State';
      zipDisplay = locale === 'en_CA' ? 'Postal Code' : 'ZIP Code';
      this.parent.filters.importGroup({
        name: 'Region Filters',
        filters: [
          {
            name: 'years',
            display_name: 'Year'
          }, {
            name: 'states',
            display_name: stateDisplay
          }, {
            name: 'zones',
            display_name: 'Zone'
          }, {
            name: 'zips',
            display_name: zipDisplay
          }
        ]
      });
      return this.parent.filters.importGroup({
        name: 'Operation Filters',
        filters: [
          {
            name: 'companies',
            display_name: 'Company'
          }, {
            name: 'owners',
            display_name: 'User'
          }, {
            name: 'farms',
            display_name: 'Farm',
            "class": 'dropup'
          }, {
            name: 'fields',
            display_name: 'Field',
            "class": 'dropup'
          }
        ]
      });
    };

    BaseHandler.prototype.finishRunning = function() {
      var promise;
      this.filters = ko.toJSON(this.parent.filters.jsonize());
      if (this.currentOutput != null) {
        promise = this.currentOutput.buildTable();
      }
      if ((promise != null) && (promise.then != null)) {
        return promise.then((function(_this) {
          return function() {
            if ($.contains(document, _this.parent.msg[0]) && _this.parent.msg.length !== 0) {
              _this.parent.msg.message_writer('success', 'Report Finished');
              return _this.parent.msg.message_writer('hide');
            }
          };
        })(this));
      } else {
        if ($.contains(document, this.parent.msg[0]) && this.parent.msg.length !== 0) {
          this.parent.msg.message_writer('success', 'Report Finished');
          return this.parent.msg.message_writer('hide');
        }
      }
    };

    BaseHandler.prototype.refreshReport = function() {
      var refreshLayout;
      refreshLayout = true;
      if (this.beforeApply != null) {
        refreshLayout = this.beforeApply();
      }
      if ($.contains(document, this.parent.msg[0]) && this.parent.msg.length !== 0) {
        this.parent.msg.message_writer('info', 'Running Report...');
      }
      this.filters = ko.toJSON(this.parent.filters.jsonize());
      if (refreshLayout) {
        return this.loadLayout({
          postOptions: {
            query: this.filters
          }
        });
      } else {
        return this.afterLoadLayout();
      }
    };

    BaseHandler.prototype.afterLoadLayout = function() {
      var browser_added_width, master_sidebar, sidebar_content;
      this.parent.resize();
      master_sidebar = App.sidebar.element.find('.master_sidebar');
      sidebar_content = App.sidebar.element.find('.sidebar_content');
      if (sidebar_content[0].scrollHeight > sidebar_content.height()) {
        master_sidebar.css({
          'width': '296px',
          'padding-left': '4px'
        });
        sidebar_content.css({
          'overflow-y': 'auto'
        });
        browser_added_width = master_sidebar.width() - sidebar_content.width();
        if (browser_added_width === 0) {
          sidebar_content.css({
            'overflow-y': 'auto',
            'padding-right': '17px'
          });
        }
      }
      return this.finishRunning();
    };

    BaseHandler.prototype.setDefaultsAndRun = function(years_to_add, months_to_add, days_to_add, default_filters, dateRangePickerDirection, doCrapWithYearsFilter) {
      var cyear, filter, filtersListening, fname, group, i, index, j, key, len, len1, opt, options, ref, ref1, year;
      if (years_to_add == null) {
        years_to_add = 0;
      }
      if (months_to_add == null) {
        months_to_add = 0;
      }
      if (days_to_add == null) {
        days_to_add = 0;
      }
      if (default_filters == null) {
        default_filters = {};
      }
      if (dateRangePickerDirection == null) {
        dateRangePickerDirection = 'up';
      }
      if (doCrapWithYearsFilter == null) {
        doCrapWithYearsFilter = true;
      }
      App.sidebar.element.find('.dpl').datepicker();
      App.sidebar.element.find('.drp').daterangepicker({
        autoApply: true,
        drops: dateRangePickerDirection,
        parentEl: '#bs2-container'
      });
      year = this.parent.filters.findInGroup('years');
      if (year && doCrapWithYearsFilter && year.auto_select_by_default_flag === false) {
        if (year.selected_values().length === 0) {
          cyear = new Date();
          cyear.setFullYear(cyear.getFullYear() + years_to_add);
          cyear.setMonth(cyear.getMonth() + months_to_add);
          cyear.setDate(cyear.getDate() + days_to_add);
          year.populateValues([
            {
              key: cyear.getFullYear(),
              value: cyear.getFullYear()
            }
          ]);
          year.applyFilter({
            key: cyear.getFullYear(),
            value: cyear.getFullYear()
          }, false);
        }
        filtersListening = [];
        ref = this.parent.filters.filter_groups();
        for (i = 0, len = ref.length; i < len; i++) {
          group = ref[i];
          ref1 = group.filters();
          for (index = j = 0, len1 = ref1.length; j < len1; index = ++j) {
            filter = ref1[index];
            if (filter.listenForYear != null) {
              filtersListening.push(filter);
              filter.listenForYear(year.selected_values());
            }
          }
        }
        year.selected_values.subscribe(function(newValue) {
          var k, len2, results;
          results = [];
          for (k = 0, len2 = filtersListening.length; k < len2; k++) {
            filter = filtersListening[k];
            results.push(filter.listenForYear(newValue));
          }
          return results;
        });
      }
      for (fname in default_filters) {
        options = default_filters[fname];
        filter = this.parent.filters.findInGroup(fname);
        for (key in options) {
          opt = options[key];
          filter.populateValues([
            {
              key: opt.key,
              value: opt.value
            }
          ]);
          filter.applyFilter({
            key: opt.key,
            value: opt.value
          }, false);
        }
      }
      return this.parent.filters.fetchFilters(this.filterUrl, (function(_this) {
        return function() {
          return _this.refreshReport();
        };
      })(this));
    };

    BaseHandler.prototype.afterResize = function() {
      if (this.currentOutput != null) {
        return this.currentOutput.resizeTable();
      }
    };

    BaseHandler.prototype.print = function() {
      var url, win;
      url = this.printUrl + '?' + $.param({
        query: this.filters
      });
      win = window.open(url, '_blank');
      return win.onload = function() {
        return win.print();
      };
    };

    BaseHandler.prototype.destroy = function() {
      BaseHandler.__super__.destroy.call(this);
      App.sidebar.element.find('.master_sidebar').css('width', '');
      App.sidebar.element.find('.sidebar_content').css({
        'overflow-y': '',
        'padding-right': ''
      });
      $(this.layoutSelector).empty();
      this.parent.filters.clearAllFilters();
      return this.parent.appliedFilters = null;
    };


    /*
    Gets the first date of the year
     */

    BaseHandler.prototype.getFirstDateOfYear = function() {
      var date, string, year;
      date = new Date();
      year = date.getFullYear();
      string = '01/01/' + year;
      return string;
    };


    /*
    Turns a date into a string that fits into a datepicker input type (in bootstrap)
     */

    BaseHandler.prototype.getDateString = function(date) {
      var day, month, string, year;
      day = this.zeroPad(date.getDate(), 2);
      month = this.zeroPad(date.getMonth() + 1, 2);
      year = date.getFullYear();
      string = month + '/' + day + '/' + year;
      return string;
    };


    /*
    Does some fancy zero padding to help the getDateString function work the way we want it to.
    Posted by a stackoverflow user:
        http://stackoverflow.com/questions/2998784/how-to-output-integers-with-leading-zeros-in-javascript
     */

    BaseHandler.prototype.zeroPad = function(num, places) {
      var zero;
      zero = places - num.toString().length + 1;
      return Array(+(zero > 0 && zero)).join('0') + num;
    };

    return BaseHandler;

  })(Handler);

}).call(this);
